import { RouteNamesAuth } from 'routes/enum'
import { MenuItem } from './sideBar'
import {
  Cards,
  File,
  Gear,
  MonitorPlay,
  Newspaper,
  Sparkle,
  Star,
  UmbrellaSimple,
} from 'phosphor-react'

export const backOfficeMenu: MenuItem[] = [
  {
    label: 'Brokers',
    url: RouteNamesAuth.BACKOFFICE_BROKERS,
    icon: () => <UmbrellaSimple size={16} />,
  },
  {
    label: 'Produtos',
    url: RouteNamesAuth.BACKOFFICE_PRODUCTS,
    icon: () => <Star size={16} />,
  },
  {
    label: 'Categorias',
    url: RouteNamesAuth.BACKOFFICE_PRODUCT_CATEGORIES,
    icon: () => <Sparkle size={16} />,
  },
  {
    label: 'Campanhas',
    url: RouteNamesAuth.BACKOFFICE_CAMPAIGNS,
    icon: () => <Newspaper size={16} />,
  },
  {
    label: 'Webisodes',
    url: RouteNamesAuth.BACKOFFICE_WEBISODES,
    icon: () => <MonitorPlay size={16} />,
  },
  {
    label: 'Sliders',
    url: RouteNamesAuth.BACKOFFICE_SLIDERS,
    icon: () => <Cards size={16} />,
  },
  {
    label: 'Páginas',
    url: RouteNamesAuth.BACKOFFICE_PAGES,
    icon: () => <File size={16} />,
  },
  {
    label: 'Formações',
    url: RouteNamesAuth.BACKOFFICE_TRAININGS,
    icon: () => <File size={16} />,
  },
  {
    label: 'Settings',
    url: RouteNamesAuth.BACKOFFICE_SETTINGS,
    icon: () => <Gear size={16} />,
  },
]
